import { useDailySunlightStore } from '@/store/dailySunlightsStore';
import styles from './style.module.scss';

export const StatusMessage = () => {
	const { currentStatusMessage } = useDailySunlightStore();

	if (!currentStatusMessage) return null;

	return (
		<div className={styles.statusMessageContainer}>
			<div>{currentStatusMessage}</div>
		</div>
	);
};
